import React from "react";
import T from "i18n-react";
import { useSelector } from "react-redux";
import ProductTitle from "../utils/ProductTItle";
import CompleteElement from "./CompletedElement";
// import PageTitle from '../PageTitle';
import EditButton from "../EditButton/EditButton";
import Styles from "./styles.module.scss";
import CountComponent from "../../Widgets/CountComponent/CountComponent";
import SelectedOptionPrice from "./SelectedOptionPrice";

interface IConfirmationProps {
  selectedAmountName: string;
  GoTo: Function;
  menuItem: IMenuItem;
  selectedExtras: ISelectedCartExtras;
  selectedExtrasPageIndex: Record<string, number>;
  selectedPreferences: Record<string, string>;
  count: number;
  changeCount: Function;
}
function Confirmation({
  selectedAmountName,
  GoTo,
  menuItem,
  selectedExtras,
  selectedExtrasPageIndex,
  selectedPreferences,
  count,
  changeCount,
}: IConfirmationProps) {
  const Extras = useSelector((state: any) => state.Extras);
  const MenuItemsAsExtra = useSelector((state: any) => state.MenuItemsAsExtra);
  // const [tempCount, setTempCount] = useState(count);

  const renderPreferences = () => {
    return Object.keys(selectedPreferences).map((item, i) => {
      const data = selectedPreferences[item];
      return <CompleteElement key={"pref" + i} title={data} />;
    });
  };
  const getAfterDiscountPrice = (price: number, discount: number) => {
    let finalPrice = price;
    if (discount) {
      finalPrice = price - (price * discount) / 100;
    }
    return finalPrice;
  };
  const renderExtras = () => {
    return Object.keys(selectedExtras).map((item, i) => {
      const extraObj = selectedExtras[item];
      const menuItemExtra = Extras[item];
      return (
        <div className={Styles.ModSections} key={"extraDiv" + i}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <ProductTitle
              title={menuItemExtra.menu_item_extra_group_name_public}
            />
            <EditButton onClick={() => GoTo(selectedExtrasPageIndex[item])} />
          </div>
          {extraObj.map((extra: any, i: number) => {
            const data = MenuItemsAsExtra[extra.id];
            const title = `${data?.extra_name_public} ${
              extra.priceName
                ? data?.extra_pricing_options_extras
                  ? data.extra_pricing_options_extras[extra.priceName]
                      .option_name
                  : ""
                : ""
            }`;
            return (
              <div
                key={extra.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <CompleteElement key={"extra" + i} title={title} />
                <SelectedOptionPrice
                  price={
                    extra.priceName
                      ? data?.extra_pricing_options_extras
                        ? getAfterDiscountPrice(
                            data.extra_pricing_options_extras[extra.priceName]
                              .option_price,
                            data.extra_pricing_options_extras[extra.priceName]
                              .option_discount
                          ).toString()
                        : ""
                      : ""
                  }
                  count={count}
                />
              </div>
            );
          })}
        </div>
      );
    });
  };
  return (
    <>
      {/* <PageTitle title={T.translate("Menu.Confirmation") as string} /> */}
      <div
        style={{
          padding: "1rem 2.5rem 4rem 2.5rem",
        }}
      >
        <div className={Styles.ImageSectionDiv}>
          <div>
            {menuItem?.menu_item_url_photo && (
              <div className={Styles.ImageDiv}>
                <img
                  src={menuItem.menu_item_url_photo}
                  alt={menuItem.menu_item_name_public}
                />
              </div>
            )}
          </div>

          <div>
            <CountComponent
              noDelete={true}
              count={count}
              onMinusClick={() => {
                if (count !== 1) {
                  changeCount(count - 1);
                }
              }}
              onPlusClick={() => {
                changeCount(count + 1);
              }}
            />
          </div>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingTop: "1.1rem",
            }}
          >
            <ProductTitle title={menuItem.menu_item_name_public} />

            <EditButton onClick={() => GoTo(0)} />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <CompleteElement
              key={"title"}
              title={
                menuItem.menu_item_pricing_options
                  ? menuItem.menu_item_pricing_options[selectedAmountName]
                    ? menuItem.menu_item_pricing_options[selectedAmountName]
                        .option_name
                    : ""
                  : ""
              }
            />

            {/* <SelectedOptionPrice
              price={
                menuItem.menu_item_pricing_options
                  ? menuItem.menu_item_pricing_options[selectedAmountName]
                    ? priceToPounds(
                        menuItem.menu_item_pricing_options[selectedAmountName]
                          .option_price
                      )
                    : ""
                  : ""
              }
              count={count}
            /> */}
          </div>
        </div>
        {Object.keys(selectedPreferences).length > 0 ? (
          <div className={Styles.ModSections}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <ProductTitle title={T.translate("Menu.Preferences") as string} />
              <EditButton onClick={() => GoTo(1)} />
            </div>
            {renderPreferences()}
          </div>
        ) : null}

        {renderExtras()}
      </div>
    </>
  );
}

export default React.memo(Confirmation);
